import { WrapperProps } from './types/types'

export interface ContentWrapperProps extends WrapperProps {
  showContent: boolean
}

export const ContentWrapper = ({
  showContent,
  children
}: ContentWrapperProps) => {
  if (!showContent) {
    return null
  }
  return <>{children}</>
}
